import { v4 as uuidv4 } from 'uuid';

export const generateNonce = async () => {
  const nonce = uuidv4();
  const msgUint8 = new TextEncoder().encode(nonce);
  const hashBuffer = await window.crypto.subtle.digest('SHA-256', msgUint8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashNonce = hashArray
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('');

  return {
    nonce,
    hashNonce,
  };
};
